module.exports = __webpack_public_path__ + "static/WeGlot-617c87ced45818c97ecb24716440f5bb.jpg";